<div *ngIf="isLoading | async" class="overlay">
    <div class="loader">
        <img [src]="faviconlight" class="fadeInOut imagem">
    </div>
  </div>
  